import actions from "./actions";

const {
    FETCH_RESULT_SLIDES,
    FETCH_RESULT_SLIDE,
    RESET_RESULT_SLIDE
} = actions;

const initState = {
    resultSlides: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    resultSlide: { _id: null }
};

const ResultSlideReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_RESULT_SLIDES:
            return {
                ...state,
                resultSlides: data
            };
        case RESET_RESULT_SLIDE:
            return {
                ...state,
                resultSlide: initState.resultSlide
            };
        case FETCH_RESULT_SLIDE:
            return {
                ...state,
                resultSlide: data
            };
        default:
            return state;
    }
};

export default ResultSlideReducer;
